export class LockButton {
  public static isLock = false;
}
